export function isCurrentProduct(buttonText: string) {
    return buttonText.toLowerCase() === 'current plan' || buttonText.toLowerCase() === 'need more credits?';
}